import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';
import { MenuActive, MenuParam } from './../../core/bootstrap/menu.service';
import { MENU_KEY } from './../utils/constant';

@Injectable({
  providedIn: 'root',
})
export class UtilsShareService {

  isLoadParam = false;
  listButtonAll = new BehaviorSubject<any>(null);
  $menuInActive = new BehaviorSubject<MenuParam>({
    pId: 0,
    customerCode: 0,
    menuActive: [],
  });

  messageSource = new BehaviorSubject<boolean>(null);
  shareDataSignature = new BehaviorSubject<string>(null);

  constructor() { }

  getAll(): Observable<MenuParam> {
    return this.$menuInActive.asObservable();
  }

  /**
   * Add menu param
   * @param key
   * @param pId
   * @param customerCode
   */
  add(keyMenu, key: MenuActive, queryParams, param = 'Dform') {
    var index = _.findIndex(keyMenu.menuActive, ['key', key.key]);
    if (index >= 0) {
      keyMenu.menuActive.splice(index, 1, key);
    } else {
      keyMenu.menuActive.push(key);
    }
    keyMenu.pId = queryParams.pId;
    keyMenu.customerCode = queryParams.customerCode;
  }

  /**
   * Remove menu item param
   * @param key
   * @param queryParams
   */
  remove(keyMenu, key: MenuActive, queryParams) {
    var index = _.findIndex(keyMenu.menuActive, ['key', key.key]);
    if (index >= 0) {
      keyMenu.menuActive.splice(index, 1);
    }
    keyMenu.pId = queryParams.pId;
    keyMenu.customerCode = queryParams.customerCode;
  }

  /**
   * Reset tham số hiển thị trên menu detail
   */
  resetMenuParam() {
    const menuparam: MenuParam = Object.assign({
      pId: 0,
      customerCode: 0,
      menuActive: []
    })
    this.$menuInActive.next(menuparam);
  }

  /**
   * Lấy danh sách button
   */
  getAllButton(): Observable<any> {
    return this.listButtonAll.asObservable();
  }

  /**
   * Add menu param
   * @param key
   * @param pId
   * @param customerCode
   */
  addButton(btn) {
    this.listButtonAll.next(btn);
  }

  /**
   * Reset danh sách tất cả button chung
   * @param lstBtn
   */
  resetButton() {
    this.listButtonAll.next(null);
  }

  /**
   * @author PHUONGPV
   * Load danh sách menu Active
   */
  getListMenuActive(process: any, queryParams) {
    const keyMenu = this.$menuInActive.value;
    this.add(keyMenu, { key: MENU_KEY.GENERAL, number: 0 }, queryParams);
    this.add(keyMenu, { key: MENU_KEY.INFO_APPROVE, number: 0 }, queryParams);
    this.add(keyMenu, { key: MENU_KEY.SMS, number: 0 }, queryParams);
    this.add(keyMenu, { key: MENU_KEY.REPORT, number: 0 }, queryParams);
    if (process) {
      if (process.dwAccountListState && process.dwAccountListState.dwAccountList && process.dwAccountListState.dwAccountList.length > 0) {
        this.add(keyMenu, { key: MENU_KEY.ACCOUNT, number: process.dwAccountListState.dwAccountList.length }, queryParams);
      } else {
        this.remove(keyMenu, { key: MENU_KEY.ACCOUNT, number: 0 }, queryParams);
      }
      if (process.dwCardState && process.dwCardState.dwCardList && process.dwCardState.dwCardList.length > 0) {
        this.add(keyMenu, {
          key: MENU_KEY.CARD, number: process.dwCardState.dwCardList.length
        }, queryParams);
      } else {
        this.remove(keyMenu, { key: MENU_KEY.CARD, number: 0 }, queryParams);
      }
      if (process.dwInternetBankingState && process.dwInternetBankingState.dwInternetBanking) {
        this.add(keyMenu, { key: MENU_KEY.EBANKING, number: 0 }, queryParams);
      } else {
        this.remove(keyMenu, { key: MENU_KEY.EBANKING, number: 0 }, queryParams);
      }
      if (process.dwCustomerState) {
        this.add(keyMenu, { key: MENU_KEY.CUSTOMER, number: 0 }, queryParams);
      } else {
        this.remove(keyMenu, { key: MENU_KEY.CUSTOMER, number: 0 }, queryParams);
      }
      if (process.dwSmsListState && process.dwSmsListState.dwSMSBanking && process.dwSmsListState.dwSMSBanking.length > 0) {
        this.add(keyMenu, { key: MENU_KEY.SMS, number: 0 }, queryParams);
      } else {
        this.remove(keyMenu, { key: MENU_KEY.SMS, number: 0 }, queryParams);
      }
      if (process.dwCustomerPackageListState && process.dwCustomerPackageListState.dwCustomerPackageList && process.dwCustomerPackageListState.dwCustomerPackageList.length > 0) {
        this.add(keyMenu, { key: MENU_KEY.PACKAGE, number: process.dwCustomerPackageListState.dwCustomerPackageList.length }, queryParams);
      } else {
        this.remove(keyMenu, { key: MENU_KEY.PACKAGE, number: 0 }, queryParams);
      }
    }
    this.$menuInActive.next(keyMenu);
  }


  /**
   * Xử lý map thông tin của thẻ ra menu
   */
  mapListMenuCard(listCard, queryParams) {
    const listCardMenu = [];
    const visaDebit = (listCard || []).find(x => x.productCode === 'VisaDebit');
    let item = this.resetItem(queryParams);
    if (visaDebit) {
      item.name = 'Thẻ Visa Debit';
      item.badge = { color: "primary", value: 1 }
      item.route = `/dform/register-service/customer/detail/card/card-info`;
      item.cardId = visaDebit.dwCardId;
      item.cardtype = 'VisaDebit'
      this.addSubCard(visaDebit, item, queryParams);
    } else {
      item.name = 'Thẻ Visa Debit';
      item.route = `/dform/register-service/customer/detail/card/card-info`;
      item.cardtype = 'VisaDebit';
      item.children = [];
    }
    listCardMenu.push({ ...item });
    item = this.resetItem(queryParams);
    const active = listCard.find(x => x.productCode === 'Active');
    if (active) {
      item.name = 'Thẻ Active Plus';
      item.badge = { color: "primary", value: 1 }
      item.route = `/dform/register-service/customer/detail/card/card-info`;
      item.cardId = active.dwCardId;
      item.cardtype = 'Active'
      this.addSubCard(active, item, queryParams);
    } else {
      item.name = 'Thẻ Active Plus';
      item.badge = ''
      item.route = `/dform/register-service/customer/detail/card/card-info`;
      item.cardtype = 'Active';
      item.children = [];
    }
    listCardMenu.push({ ...item });
    item = this.resetItem(queryParams);
    const qnCard = listCard.find(x => x.productCode === 'QN');
    if (qnCard) {
      item.name = 'Thẻ Quân nhân';
      item.type = 'link';
      item.badge = { color: "primary", value: 1 }
      item.route = `/dform/register-service/customer/detail/card/card-info`;
      item.cardId = qnCard.dwCardId;
      item.cardtype = 'QN';
      item.children = [];
      item.badge = { color: "primary", value: 1 }
    } else {
      item.name = 'Thẻ Quân nhân';
      item.type = 'link';
      item.badge = ''
      item.route = `/dform/register-service/customer/detail/card/card-info`;
      item.cardtype = 'QN'
    }
    listCardMenu.push({ ...item });
    return listCardMenu;
  }

  resetItem(queryParams) {
    return {
      customerCode: queryParams?.customerCode,
      icon: null,
      isData: false,
      name: '',
      pId: queryParams?.pId,
      route: '',
      type: 'sub',
      cardId: null,
      cardtype: null,
      children: [],
      badge: null
    }
  }


  addSubCard(cardSub, item, queryParams) {
    item.children = [];
    (cardSub.listSubCard || []).forEach((element, index) => {
      const itemSub = {
        icon: null,
        name: 'Thẻ phụ ' + (index + 1),
        route: `/dform/register-service/customer/detail/card/sub-card`,
        type: 'link',
        customerCode: queryParams?.customerCode,
        pId: queryParams?.pId,
        cardId: cardSub.dwCardId,
        scId: element.dwSubCardId,
        badge: { color: "primary", value: 1 }
      }
      item.children.push(itemSub);
    });
  }

  checkShowButtonByProcessStatus(event) {
    this.messageSource.next(event);
  }
}
